import { Routes } from '@angular/router';
import { provideStates } from '@ngxs/store';

import { anonymousGuard } from '@shared/guards/anonymous.guard';
import { authGuard } from './auth/guards/auth.guard';
import { RoutingPath } from '@shared/enums/routing-path.enum';
import { AuthComponent } from './auth/auth.component';
import { RoutingService } from '@shared/services/routing.service';
import { onboardingGuard } from './onboarding/onboarding.guard';
import { LoginState } from './login/store/login.state';
import {
  forgotPasswordTokenGuard,
} from './forgot-password/guards/forgot-password-token.guard';
import {
  NotificationsState,
} from './auth/notifications/store/notifications.state';
import {
  notificationsLoaderGuard,
} from './auth/notifications/guards/notifications-loader.guard';
import { UserState } from '@user/store/user.state';
import { userLoaderGuard } from '@user/guards/user-loader.guard';
import {
  DevelopmentsState,
} from './auth/developments/store/developments.state';
import { fcmRegistrationGuard } from './auth/guards/fcm-registration.guard';

export const appRoutes: Routes = [
  {
    path: RoutingPath.ONBOARDING,
    canMatch: [onboardingGuard],
    loadComponent: () =>
        import('./onboarding/onboarding.component')
            .then((m) => m.OnboardingComponent),
  },
  {
    path: RoutingPath.LOGIN,
    canMatch: [anonymousGuard],
    providers: [provideStates([LoginState])],
    loadComponent: () =>
        import('./login/login.component')
            .then((m) => m.LoginComponent),
  },
  {
    path: RoutingPath.FORGOT_PASSWORD,
    canMatch: [anonymousGuard],
    loadChildren: () =>
        import('./forgot-password/forgot-password.routes')
            .then((m) => m.forgotPasswordRoutes),
  },
  {
    // PAY ATTENTION!
    // This path shouldn't be changed without an alignment with back-end.
    // It's used to deep linking password recover.
    // Guard extracts token, saves to ForgotPasswordState, then redirects to
    // new-password.
    path: RoutingService.FORGOT_PASSWORD_BACKEND_REDIRECT,
    canActivate: [forgotPasswordTokenGuard],
    children: [],
  },
  {
    path: RoutingPath.REGISTER,
    canMatch: [anonymousGuard],
    loadChildren: () =>
        import('./register/register.routes')
            .then((m) => m.registerRoutes),
  },
  {
    path: RoutingPath.THEME,
    providers: [provideStates([NotificationsState, DevelopmentsState])],
    loadComponent: () =>
        import('./theme/theme.component')
            .then((m) => m.ThemeComponent),
  },
  {
    path: '',
    component: AuthComponent,
    canMatch: [authGuard],
    canActivate: [notificationsLoaderGuard, userLoaderGuard, fcmRegistrationGuard],
    providers: [provideStates([NotificationsState, UserState])],
    loadChildren: () =>
        import('./auth/auth.routes')
            .then((m) => m.authRoutes),
  },
  { path: '**', redirectTo: '' },
];
